
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apikeys",
      function () {
        return require("private-next-pages/apikeys/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apikeys"])
      });
    }
  